export default __webpack_public_path__ + "318c3ad92b2ef4f96cacc8bc8b1d1481.svg";